import { TextHighlightElement } from '../types';

export default (node?: Element | Node | null): node is TextHighlightElement => {
  return Boolean(node && 'tagName' in node && node.tagName.toLowerCase() === 'rw-highlight');
};
